/** Host-independent progress for chart tiles attempted by the gdtile protocol. */
class TileProgress {
  requested = $state(0);
  settled = $state(0);
  firstRequestedAt = $state<number | null>(null);

  request(): void {
    if (this.requested === 0) this.firstRequestedAt = Date.now();
    this.requested++;
  }

  settle(): void {
    this.settled++;
  }

  reset(): void {
    this.requested = 0;
    this.settled = 0;
    this.firstRequestedAt = null;
  }
}

export const tileProgress = new TileProgress();

export function chartLoadingTimeoutMessage(requested: number, affected = ''): string {
  return requested === 0
    ? "The chart isn't requesting any tiles."
    : `Charts are taking too long to load — ${affected || 'the chart services'} aren't responding.`;
}
